import { LogoutModalTranslations } from "./types";

export const deTranslations: LogoutModalTranslations = {
    title: "Achtung!",
    gameSubtitle: "Sind Sie sicher? Wenn Sie die Simulation jetzt verlassen, können Sie Ihre virtuellen Patient:innen nicht weiterbehandeln.",
    subtitle:"Sind Sie sicher?",
    logoutText: "Abmelden", 
    cancelText: "Abbrechen",
};